export const palette = {
  variant: 'otherAlpha',
  accent: 'otherBeta',
}
